{
  "version": 1,
  "asset_id": "c3a283e3-5fe0-48b7-a3e6-5226bc46eb78",
  "project_id": "1820e758-46fa-46b0-bd5a-016534d0d263",
  "url": "/__l5e/assets-v1/c3a283e3-5fe0-48b7-a3e6-5226bc46eb78/ind-saas-640.avif",
  "r2_key": "a/v1/1820e758-46fa-46b0-bd5a-016534d0d263/c3a283e3-5fe0-48b7-a3e6-5226bc46eb78/ind-saas-640.avif",
  "original_filename": "ind-saas-640.avif",
  "size": 5317,
  "content_type": "image/avif",
  "created_at": "2026-07-25T02:26:15Z"
}
